import { QCFormValues } from "../../questionnaire.types";

export const initialValues: QCFormValues = {
  title: "",
  description: "",
  supplierQuestionList: [],
  productQuestionList: []
};
